import styled from "styled-components";

const Footer = styled.footer`
  height: 130px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #212226;
`;

const FooterText = styled.h6`
  color: white;
`;

export { Footer, FooterText };
